export default ()=>{
  return(`

    .PaddingTopXS {
      padding-top: 3px;
    }

    .PaddingRightXS {
      padding-right: 3px;
    }

    .PaddingBottomXS {
      padding-bottom: 3px;
    }

    .PaddingLeftXS {
      padding-left: 3px; 
    }

    .PaddingTopS {
      padding-top: 13px;
    }

    .PaddingRightS {
      padding-right: 13px;
    }

    .PaddingBottomS {
      padding-bottom: 13px;
    }

    .PaddingLeftS {
      padding-left: 13px; 
    }

    .PaddingTopM {
      padding-top: 19px;
    }

    .PaddingRightM {
      padding-right: 19px;
    }

    .PaddingBottomM {
      padding-bottom: 19px;
    }

    .PaddingLeftM {
      padding-left: 19px; 
    }

    .PaddingTopL {
      padding-top: 29px;
    }

    .PaddingRightL {
      padding-right: 29px;
    }

    .PaddingBottomL {
      padding-bottom: 29px;
    }

    .PaddingLeftL {
      padding-left: 29px; 
    }
  `)
}
